/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ContentType {
    CONTRACT = 'contract',
    CONSULTATION = 'consultation',
    CONSULTATION_DRAFT = 'consultationDraft',
}
